module.exports = __webpack_public_path__ + "static/media/book.cd7d581c.svg";